import React, { BaseSyntheticEvent, FunctionComponent } from "react";
import { CheckedCheckBox as CheckedCheckBoxTemplate, UncheckedCheckBox as UncheckedCheckBoxTemplate } from "@iventis/styles/src/components";
import { styled } from "@iventis/styles";
import { Checkbox, useTheme } from "@mui/material";
import { Body2 } from "@iventis/styles/src/components/texts";
import { Theme } from "@emotion/react";

export const CheckedCheckBox = () => {
    const theme: Theme = useTheme<Theme>();
    return (
        <CheckedCheckBoxTemplate
            borderStyle={theme.dataTableTheme.checkBox.checked.border}
            backgroundColour={theme.dataTableTheme.checkBox.checked.background}
            tickColour={theme.dataTableTheme.checkBox.checked.tick.color}
            tickWeight={theme.dataTableTheme.checkBox.checked.tick.weight}
            size={15}
        />
    );
};

export const UncheckedCheckBox = () => {
    const theme: Theme = useTheme<Theme>();
    return <UncheckedCheckBoxTemplate borderStyle={theme.dataTableTheme.checkBox.checked.border} backgroundColour={theme.dataTableTheme.checkBox.checked.background} size={15} />;
};

export const CheckBoxSelection: FunctionComponent<{
    value: string;
    displayName: string;
    checked: boolean;
    onChange: (e: BaseSyntheticEvent) => void;
    icon?: React.ReactNode;
    checkedIcon?: React.ReactNode;
    dataTestId?: string;
}> = ({ value, displayName, checked, onChange, icon, checkedIcon, dataTestId }) => (
    <StyledCheckList data-testid={dataTestId} htmlFor={value}>
        <Body2 style={{ display: "inline-block", marginRight: "5px" }}>{displayName}</Body2>
        <Checkbox
            checked={checked}
            icon={icon || <UncheckedCheckBox />}
            checkedIcon={checkedIcon || <CheckedCheckBox />}
            name={value}
            id={value}
            color="default"
            onChange={onChange}
        />
    </StyledCheckList>
);

const StyledCheckList = styled.label`
    max-height: 100px;
    overflow-y: auto;
    display: flex;
    justify-content: space-between;
    align-items: center;
    :hover {
        cursor: pointer;
    }
`;
